<template>
    <div
        class="new-collection-page container-fluid page-card admin-weflix-new-collection weflix-admin-newCollection"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div class="new-collection-tabs-card">
            <div class="new-collection-toolbar" role="banner">
                <div class="new-collection-toolbar__lead">
                    <h2 class="new-collection-toolbar__title">Nova Coleção</h2>
                    <p class="new-collection-toolbar__subtitle">
                        Crie uma nova coleção para seus vídeos
                    </p>
                </div>
                <div class="new-collection-toolbar__actions">
                    <v-btn
                        variant="outlined"
                        color="primary"
                        :size="$vuetify.display.xs ? 'default' : 'large'"
                        :loading="fillingPreview"
                        :disabled="fillingPreview || !loaderImage"
                        @click="fillPreviewData"
                    >
                        Preencher dados
                    </v-btn>
                </div>
            </div>
        </div>

        <div class="new-collection-shell">
            <div class="new-collection-stack">
                <div class="new-collection-stack__main">
                <div class="new-collection-subpanel new-collection-subpanel--details">
                <div class="form-group">
                    <div class="form-label">
                        <label
                            >Nome da coleção<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            required
                            class="form-control"
                            v-model="name"
                            placeholder="Título da sua coleção"
                        />
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-label">
                        <label
                            >Descrição da coleção<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-textarea full-descroption">
                        <textarea
                            class="form-control"
                            v-model="description"
                            maxlength="300"
                            rows="4"
                            placeholder="Descrição da coleção"
                        ></textarea>
                    </div>
                </div>

                <!-- Status da Coleção -->
                <div class="form-group">
                    <div class="form-label">
                        <label>Status da Coleção</label>
                    </div>
                    <div class="form-select">
                        <select v-model="status" class="form-control">
                            <option value="1">Ativo</option>
                            <option value="0">Inativo</option>
                        </select>
                    </div>
                </div>

                <!-- Tipo de Venda -->
                <div class="form-group venda-type">
                    <div class="form-label venda-type__head">
                        <label id="new-collection-venda-type-label"
                            >Tipo de Venda</label
                        >
                        <small class="venda-type__hint"
                            >Assinatura inclui a coleção no plano; venda avulsa
                            cobra o acesso só desta coleção.</small
                        >
                    </div>
                    <div
                        class="venda-options"
                        role="radiogroup"
                        aria-labelledby="new-collection-venda-type-label"
                    >
                        <div
                            class="venda-option"
                            :class="{ active: !vendaAvulsa }"
                            @click="vendaAvulsa = false"
                        >
                            <input
                                type="radio"
                                v-model="vendaAvulsa"
                                :value="false"
                                id="new-collection-venda-assinatura"
                            />
                            <label for="new-collection-venda-assinatura">
                                <span class="venda-option__icon" aria-hidden="true">
                                    <fa icon="fas fa-user-check"></fa>
                                </span>
                                <span class="venda-option__title">Assinatura</span>
                            </label>
                        </div>
                        <div
                            class="venda-option"
                            :class="{ active: vendaAvulsa }"
                            @click="vendaAvulsa = true"
                        >
                            <input
                                type="radio"
                                v-model="vendaAvulsa"
                                :value="true"
                                id="new-collection-venda-avulsa"
                            />
                            <label for="new-collection-venda-avulsa">
                                <span class="venda-option__icon" aria-hidden="true">
                                    <fa icon="fas fa-shopping-cart"></fa>
                                </span>
                                <span class="venda-option__title"
                                    >Venda avulsa</span
                                >
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Mensagem informativa para modelo de assinatura -->
                <div v-if="!vendaAvulsa" class="info-box">
                    <div class="info-box-header">
                        <h4>Modelo de Assinatura</h4>
                    </div>
                    <div class="info-box-content">
                        <p>
                            No modelo de assinatura, o conteúdo do curso será
                            disponibilizado junto aos demais em um modelo de
                            assinatura.
                        </p>
                    </div>
                </div>

                <!-- Campos que aparecem quando venda avulsa está ativa -->
                <div v-else class="info-box row ma-0">
                    <div class="col-12 col-lg-4 m-0 p-2 py-md-0">
                        <div class="form-group m-0">
                            <div class="form-label">
                                <label>Preço (R$)</label>
                            </div>
                            <div class="form-input price-input">
                                <span class="currency-symbol">R$</span>
                                <input
                                    type="number"
                                    class="form-control price-info"
                                    v-model="preco"
                                    placeholder="0.00"
                                    step="0.01"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 m-0 p-2 py-md-0">
                        <div class="form-group m-0">
                            <div class="form-label">
                                <label>Número de Parcelas</label>
                            </div>
                            <div class="form-select">
                                <select
                                    v-model="numeroParcelas"
                                    class="form-control"
                                >
                                    <option value="1">1x</option>
                                    <option value="2">2x</option>
                                    <option value="3">3x</option>
                                    <option value="4">4x</option>
                                    <option value="5">5x</option>
                                    <option value="6">6x</option>
                                    <option value="7">7x</option>
                                    <option value="8">8x</option>
                                    <option value="9">9x</option>
                                    <option value="10">10x</option>
                                    <option value="11">11x</option>
                                    <option value="12">12x</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 m-0 p-2 py-md-0">
                        <div class="form-group m-0">
                            <div class="form-label">
                                <label>Tempo de Disponibilidade</label>
                            </div>
                            <div class="form-select">
                                <select
                                    v-model="tempoDisponibilidade"
                                    class="form-control"
                                >
                                    <option value="30">30 dias</option>
                                    <option value="60">60 dias</option>
                                    <option value="90">90 dias</option>
                                    <option value="180">180 dias</option>
                                    <option value="365">365 dias</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

                <div class="new-collection-subpanel new-collection-subpanel--cover">
                <div style="position: relative">
                    <div
                        class="col-form-inner col-12 col-md-12 col-lg-12"
                        v-if="imagePreviewCover"
                    >
                        <div class="form-group imageCoverPreview">
                            <img class="coverVideo" :src="imagePreviewCover" />
                        </div>
                    </div>
                    <div
                        class="col-form-inner col-12 input-video"
                    >
                        <div class="form-group">
                            <div class="form-label">
                                <label>Capa da Coleção - Horizontal </label>
                            </div>
                            <div class="form-file uploadVideoBox">
                                <div class="file-wrapper primary">
                                    <span
                                        class="thumbnail thumb-img"
                                        :style="
                                            imagePreviewCover
                                                ? { height: '2.5rem' }
                                                : { height: '6.5rem' }
                                        "
                                    >
                                        <span class="icon" v-if="loaderImage">
                                            <svg
                                                width="46"
                                                height="39"
                                                viewBox="0 0 46 39"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                v-if="!imagePreviewCover"
                                            >
                                                <path
                                                    d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                    stroke="#9D9FA3"
                                                    stroke-width="1.25714"
                                                ></path>
                                                <rect
                                                    x="1.00049"
                                                    y="1.40454"
                                                    width="43.9461"
                                                    height="36.1909"
                                                    rx="2.58507"
                                                    stroke="#9D9FA3"
                                                    stroke-width="1.25714"
                                                ></rect>
                                                <circle
                                                    cx="14.8948"
                                                    cy="10.6676"
                                                    r="3.71629"
                                                    stroke="#9D9FA3"
                                                    stroke-width="1.25714"
                                                ></circle>
                                            </svg>
                                        </span>
                                        <span class="text" v-if="loaderImage">
                                            Clique aqui para selecionar a imagem
                                        </span>
                                        <LoaderImage :hasReady="loaderImage" />
                                    </span>
                                    <input
                                        class="form-control"
                                        type="file"
                                        @change="updateFileCover"
                                        accept=".png, .jpg, .jpeg, .webp"
                                    />
                                </div>
                                <div class="form-caption">
                                    <div class="caption"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr v-if="false" />

                <div style="position: relative" v-if="false">
                    <div class="col-form-inner col-12 col-md-12 col-lg-12">
                        <div
                            class="form-group imageCoverPreview"
                            v-if="imagePreviewCover2"
                        >
                            <img
                                class="coverVideo"
                                :src="imagePreviewCover2"
                                style="
                                    width: 240px !important;
                                    height: 440px !important;
                                "
                            />
                        </div>
                    </div>
                    <div
                        class="col-form-inner col-12 col-md-12 col-lg-12 input-video"
                    >
                        <div class="form-group">
                            <div class="form-label">
                                <label>Capa da Coleção - Vertical </label>
                            </div>
                            <div class="form-file">
                                <div class="file-wrapper primary">
                                    <span
                                        class="thumbnail thumb-img"
                                        :style="
                                            imagePreviewCover2
                                                ? { height: '2.5rem' }
                                                : { height: '6.5rem' }
                                        "
                                    >
                                        <span class="icon" v-if="loaderImage2">
                                            <svg
                                                width="46"
                                                height="39"
                                                viewBox="0 0 46 39"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                v-if="!imagePreviewCover2"
                                            >
                                                <path
                                                    d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                                    stroke="#9D9FA3"
                                                    stroke-width="1.25714"
                                                ></path>
                                                <rect
                                                    x="1.00049"
                                                    y="1.40454"
                                                    width="43.9461"
                                                    height="36.1909"
                                                    rx="2.58507"
                                                    stroke="#9D9FA3"
                                                    stroke-width="1.25714"
                                                ></rect>
                                                <circle
                                                    cx="14.8948"
                                                    cy="10.6676"
                                                    r="3.71629"
                                                    stroke="#9D9FA3"
                                                    stroke-width="1.25714"
                                                ></circle>
                                            </svg>
                                        </span>
                                        <span class="text" v-if="loaderImage">
                                            Clique aqui para selecionar a imagem
                                        </span>
                                        <LoaderImage :hasReady="loaderImage2" />
                                    </span>
                                    <input
                                        class="form-control"
                                        type="file"
                                        @change="updateFileCover2"
                                        accept=".png, .jpg, .jpeg, .webp"
                                    />
                                </div>
                                <div class="form-caption">
                                    <div class="caption"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                </div>

                <div class="new-collection-subpanel new-collection-subpanel--actions">
        <div
            class="new-collection-actions d-flex align-items-center justify-content-center justify-content-md-end ga-3 mt-0"
        >
            <v-btn
                variant="outlined" color="primary" :size="$vuetify.display.xs ? 'default' : 'large'"
                @click="() => this.$router.push('/admin/colecoes')"
            >
                Cancelar
            </v-btn>
            <v-btn
                variant="flat" color="primary" :size="$vuetify.display.xs ? 'default' : 'large'"
                :width="$vuetify.display.xs ? 120 : 140"
                :disabled="!loaderImage"
                :class="{ disabled: !loaderImage }"
                @click="newCollection"
            >
                Salvar
            </v-btn>
        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import apiCollections from '@/utils/Weflix/collections';
    import LoaderImage from '@/components/Weflix/LoaderImage';
    import apiAWS from '@/utils/storage/aws';
    import { toast } from 'vue3-toastify';
    export default {
        data() {
            return {
                name: '',
                description: '',
                coverVideo: '',
                imagePreviewCover: '',
                loaderImage: true,
                vendaAvulsa: false,
                preco: '',
                numeroParcelas: '1',
                tempoDisponibilidade: '1',
                imageCover2: '',
                imagePreviewCover2: '',
                loaderImage2: true,
                status: 1,
                fillingPreview: false,
            };
        },
        computed: {
            ...mapState(['token']),
        },
        components: {
            LoaderImage,
        },
        methods: {
            ...mapActions(['storeCurrentCollections']),

            deleteVideo(id, name) {
                this.deleteItem = true;
                this.nameItem = name;
            },
            closeDialog() {
                this.deleteItem = false;
            },
            async newCollection() {
                const payload = {
                    comercialName: this.name,
                    name: this.name,
                    status: this.status,
                    shortDescription: this.description,
                    imagePath: this.coverVideo,
                    vendaAvulsa: this.vendaAvulsa,
                    price: this.vendaAvulsa ? this.preco : null,
                    installment: this.vendaAvulsa ? this.numeroParcelas : null,
                    dayExpired: this.vendaAvulsa
                        ? this.tempoDisponibilidade
                        : null,
                    url: this.name
                        .toLowerCase()
                        .replace(/\s+/g, '-')
                        .replace(/[ç]/g, 'c')
                        .replace(/[^\w-]/g, ''),
                    imagePath2: this.imageCover2,
                };
                console.log(payload);
                try {
                    const response = await apiCollections.newCollection(
                        this.token,
                        payload
                    );
                    this.storeCurrentCollections({
                        currentCollections: response,
                    });
                    const id = response.id;
                    this.$router.push('/admin/colecao/' + id);
                } catch (error) {
                    console.error('Erro ao criar Coleção:', error);
                }
            },
            updateContentLongDescription(value) {
                this.description = value;
            },
            async putFileAws(url, file) {
                try {
                    const response = await apiAWS.putFileAWS(url, file);
                } catch (error) {
                    console.error('Erro ao enviar arquivo para AWS');
                }
            },
            async updateFileCover(event) {
                this.loaderImage = false;
                const file = event.target.files[0];
                this.imagePreviewCover = URL.createObjectURL(file);
                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.coverVideo = response.token;
                    this.loaderImage = true;
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            async updateFileCover2(event) {
                this.loaderImage2 = false;
                const file = event.target.files[0];
                this.imagePreviewCover2 = URL.createObjectURL(file);
                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name
                    );
                    this.putFileAws(response.url, file);
                    this.imageCover2 = response.token;
                    this.loaderImage2 = true;
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
            isBlank(value) {
                return value == null || String(value).trim() === '';
            },
            createDemoImageFile(label, width, height, filename) {
                return new Promise((resolve, reject) => {
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    if (!ctx) {
                        reject(new Error('Canvas não disponível'));
                        return;
                    }

                    const gradient = ctx.createLinearGradient(0, 0, width, height);
                    gradient.addColorStop(0, '#0f172a');
                    gradient.addColorStop(0.55, '#250891');
                    gradient.addColorStop(1, '#1ac7d0');
                    ctx.fillStyle = gradient;
                    ctx.fillRect(0, 0, width, height);

                    ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
                    ctx.font = `600 ${Math.max(28, Math.round(width / 22))}px sans-serif`;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(String(label).slice(0, 32), width / 2, height / 2);

                    canvas.toBlob((blob) => {
                        if (!blob) {
                            reject(new Error('Falha ao gerar imagem'));
                            return;
                        }
                        resolve(
                            new File([blob], filename, {
                                type: 'image/png',
                                lastModified: Date.now(),
                            }),
                        );
                    }, 'image/png');
                });
            },
            async uploadCoverFile(file) {
                this.loaderImage = false;
                if (this.imagePreviewCover && String(this.imagePreviewCover).startsWith('blob:')) {
                    URL.revokeObjectURL(this.imagePreviewCover);
                }
                this.imagePreviewCover = URL.createObjectURL(file);
                try {
                    const response = await apiAWS.getSignatureImage(
                        this.token,
                        file.name,
                    );
                    await this.putFileAws(response.url, file);
                    this.coverVideo = response.token;
                    this.loaderImage = true;
                } catch (error) {
                    this.loaderImage = true;
                    console.error('Erro na geração do TOKEN AWS', error);
                    throw error;
                }
            },
            async fillPreviewData() {
                if (this.fillingPreview) return;
                this.fillingPreview = true;
                try {
                    const stamp = Date.now().toString().slice(-5);
                    const name = `Coleção demonstração ${stamp}`;

                    if (this.isBlank(this.name)) this.name = name;
                    if (this.isBlank(this.description)) {
                        this.description =
                            'Coleção introdutória com vídeos práticos para acelerar o aprendizado e organizar o conteúdo da sua loja.';
                    }
                    if (this.status == null || this.status === '') this.status = 1;

                    if (!this.vendaAvulsa) {
                        this.vendaAvulsa = true;
                    }
                    if (this.isBlank(this.preco)) this.preco = '97.90';
                    if (this.isBlank(this.numeroParcelas) || this.numeroParcelas === '1') {
                        this.numeroParcelas = '3';
                    }
                    if (
                        this.isBlank(this.tempoDisponibilidade)
                        || this.tempoDisponibilidade === '1'
                    ) {
                        this.tempoDisponibilidade = '90';
                    }

                    if (!this.coverVideo && !this.imagePreviewCover) {
                        const coverFile = await this.createDemoImageFile(
                            this.name,
                            1920,
                            200,
                            `colecao-capa-${stamp}.png`,
                        );
                        await this.uploadCoverFile(coverFile);
                    }

                    this.notify('Dados de demonstração preenchidos.', 'success');
                } catch (error) {
                    console.error('Erro ao preencher dados da coleção:', error);
                    this.notify('Não foi possível gerar a capa de demonstração.', 'error');
                } finally {
                    this.fillingPreview = false;
                }
            },
        },
    };
</script>

<style scoped>
    @import url(./global.css);

    .new-collection-page.container-fluid.page-card {
        max-width: 100%;
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .new-collection-tabs-card {
        padding: 1rem;
    }

    .new-collection-toolbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.75rem 1rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .new-collection-toolbar__lead {
        min-width: 0;
        flex: 1 1 auto;
        text-align: left;
    }

    .new-collection-toolbar__title {
        margin: 0;
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.3;
        color: #1a1d26;
    }

    .new-collection-toolbar__subtitle {
        margin: 0.25rem 0 0 0;
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-size: 0.875rem;
        line-height: 1.45;
        color: #6b7280;
    }

    .new-collection-toolbar__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5rem;
        flex-shrink: 0;
    }

    .new-collection-shell {
        padding: 0 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .new-collection-shell::-webkit-scrollbar {
        display: none;
    }

    .new-collection-stack {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        max-width: 100%;
    }

    .new-collection-stack__main {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
    }

    @media (min-width: 768px) {
        .new-collection-stack__main {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1rem;
            align-items: start;
        }
    }

    .new-collection-subpanel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.5rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        min-height: 0;
    }

    .new-collection-subpanel--actions {
        padding-top: 1rem;
        padding-bottom: 1.25rem;
    }

    @media (max-width: 768px) {
        .new-collection-shell {
            padding: 0 1rem 1.25rem;
        }

        .new-collection-subpanel {
            padding: 1rem;
        }

        .new-collection-toolbar {
            padding: 0.75rem 0.85rem;
        }
    }

    .thumb-img path {
        fill: #ffffff !important;
        stroke: #aaaaaa !important;
        stroke-width: 1px !important;
    }

    .uploadVideoIcon {
        vertical-align: middle;
        width: 46px;
        padding: 8px;
        border: 1px solid #e4e4e4;
        border-radius: 10px;
    }
    .infoCollectionVideos {
        text-align: left;
        padding: 0px 20px;
    }
    svg.svg-inline--fa {
        color: silver;
    }
    .infoCollectionVideos p {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 14px;
    }
    button.editCollections {
        position: absolute;
        top: 25px;
        right: 25px;
    }
    button.editCollections svg {
        transition: all 500ms ease-in-out;
    }
    button.editCollections:hover svg {
        color: #250891;
    }
    .itemCollectionVideo .actions {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        text-align: right;
        padding: 10px;
        background-color: transparent;
        transition: all 500ms ease-in-out;
    }
    button.hoverWhite svg {
        transition: all 500ms ease-in-out;
        font-size: 15px;
    }
    button.hoverWhite:hover svg {
        color: white;
    }
    .itemCollectionVideo p {
        color: #c8c8c8;
        margin: 0;
    }
    /* Tipo de venda — cartões com rádio acessível */
    .venda-type {
        width: 100%;
        margin: 1.25rem 0;
        padding: 1rem 1.125rem 1.125rem;
        background: #f4f6fa;
        border: 1px solid #e4e7ee;
        border-radius: 14px;
    }

    .venda-type__head {
        margin-bottom: 0.875rem;
        text-align: left;
    }

    .venda-type__head label {
        display: block;
        margin-bottom: 0.25rem;
    }

    .venda-type__hint {
        display: block;
        margin: 0;
        font-size: 0.8125rem;
        line-height: 1.45;
        color: #6b7280;
        font-weight: 400;
    }

    .venda-options {
        display: flex;
        flex-wrap: wrap;
        gap: 0.75rem;
        width: 100%;
    }

    .venda-option {
        flex: 1 1 140px;
        min-width: 0;
        background: #fff;
        border: 2px solid #e4e7ee;
        border-radius: 12px;
        padding: 1rem 1rem 1.125rem;
        cursor: pointer;
        transition:
            border-color 0.2s ease,
            background 0.2s ease,
            box-shadow 0.2s ease;
        position: relative;
    }

    .venda-option.active {
        border-color: #250891;
        background: linear-gradient(180deg, #faf9ff 0%, #f3f0ff 100%);
        box-shadow: 0 4px 14px rgba(37, 8, 145, 0.12);
    }

    .venda-option:has(input:focus-visible) {
        outline: 2px solid #250891;
        outline-offset: 2px;
    }

    .venda-option input[type='radio'] {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }
    .option-icon {
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        background: #f0f0ff;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .option-content {
        flex-grow: 1;
    }
    .option-title {
        display: block;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
    }
    .option-description {
        display: block;
        font-size: 14px;
        color: #666;
        line-height: 1.4;
    }

    .venda-option__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        background: #ede9fe;
        border-radius: 12px;
        color: #250891;
        transition:
            background 0.2s ease,
            color 0.2s ease;
    }

    .venda-option__icon svg {
        width: 22px;
        height: 22px;
    }

    .venda-option.active .venda-option__icon {
        background: #250891;
        color: #fff;
    }

    .venda-option__title {
        font-size: 0.9375rem;
        font-weight: 600;
        color: #1a1d26;
        text-align: center;
        line-height: 1.3;
    }

    .venda-option.active .venda-option__title {
        color: #250891;
    }

    .venda-option:not(.active):hover {
        border-color: #c4b5fd;
        background: #fafaff;
    }
    .form-label {
        margin-bottom: 15px;
    }
    .form-label label {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 5px;
    }
    .form-label small {
        display: block;
        color: #666;
        font-size: 14px;
    }
    /* Estilos para o campo de preço */
    .price-input {
        position: relative;
    }
    .currency-symbol {
        position: absolute;
        left: 10px;
        top: 60%;
        transform: translateY(-69%);
        color: #6c757d;
    }
    .price-input input {
        padding-left: 30px;
    }
    input.form-control.price-info {
        margin: 0;
    }

    .form-select select {
        width: 100%;
        padding: 8px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        background-color: white;
        cursor: pointer;
    }
    .form-input input[type='number'] {
        width: 100%;
        padding: 8px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
    }
    /* Estilo melhorado para a caixa de informação */
    .info-box {
        background-color: #f8f9ff;
        border: 1px solid #250891;
        border-radius: 12px;
        padding: 20px;
        margin: 10px 0px;
        box-shadow: 0 2px 4px rgba(37, 8, 145, 0.1);
        width: 100%;
    }
    .info-box-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 15px;
        border-bottom: 1px solid rgba(37, 8, 145, 0.2);
        padding-bottom: 10px;
    }
    .info-box-header i {
        color: #250891;
        font-size: 24px;
    }
    .info-box-header h4 {
        color: #250891;
        margin: 0;
        font-size: 18px;
        font-weight: 600;
    }
    .info-box-content {
        color: #333;
    }
    .info-box-content p {
        margin-bottom: 15px;
        line-height: 1.5;
        font-size: 14px;
    }
    .info-box-content ul {
        list-style: none;
        padding-left: 0;
        margin: 0;
    }
    .info-box-content ul li {
        position: relative;
        padding-left: 25px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #555;
    }
    .info-box-content ul li:before {
        content: '✓';
        position: absolute;
        left: 0;
        color: #250891;
        font-weight: bold;
    }
    .info-box.form-group {
        background-color: #fff;
        padding: 25px;
    }
    select.form-control {
        border: none !important;
    }

    .v-card-title.headline {
        text-align: left !important;
        color: red;
        padding: 0 40px;
    }
    button.v-btn.v-btn--slim.v-theme--light.text-green.darken-1.v-btn--density-default.v-btn--size-default.v-btn--variant-text {
        width: 150px;
        background-color: red;
    }

    .v-overlay__content {
        width: 400px;
        max-width: 400px;
    }
    .v-card-actions {
        align-items: center;
        display: flex;
        flex: none;
        min-height: 52px;
        padding: 0 40px;
    }
    .cancel {
        background-color: white !important;
        border: 1px solid gray;
    }
    .accept {
        background-color: red !important;
        border: 1px solid red;
        color: white !important;
    }

    .exludeVideo {
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
    }
    .exludeVideo svg {
        color: #250891 !important;
    }
    input.form-check-input {
        width: 3em !important;
    }
    .form-check-input:checked {
        background-color: #250891 !important;
        border-color: #250891 !important;
    }

    .itemAtionCollections.form-check.form-switch {
        padding: 16px 40px;
    }
    img.coverVideo {
        width: 300px;
        height: auto;
        margin: 0 auto;
        filter: brightness(0.5);
    }
    .form-group {
        margin: 0;
    }
    .form-group.imageCoverPreview {
        text-align: center;
        position: relative;
    }
    .info {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
    }
    .info svg {
        font-size: 50px !important;
        color: white !important;
    }
    input.form-control.price-info {
        padding-left: 35px !important;
    }
    .venda-option small {
        font-size: 12px;
        color: #6c757d;
        text-align: center;
    }
    .venda-option label {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.625rem;
        cursor: pointer;
        margin: 0;
    }

    .col-form-inner.col-12.col-md-12.col-lg-12.info-box .form-select {
        padding: 0px 5px;
    }
    .price-info {
        text-align: left;
    }
    .exludeCollections {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
    }

    @media (max-width: 768px) {
        .weflix-admin-newCollection .titleContainer {
            padding: 0px 10px 10px 10px;
        }

        .weflix-admin-newCollection .titleContainer h3 {
            font-size: 20px;
            margin-bottom: 5px !important;
        }
        .weflix-admin-newCollection .titleContainer small {
            font-size: 12px;
            color: #666;
        }
        .weflix-admin-newCollection .form-input input {
            margin: 0px 0px 5px;
        }
        .weflix-admin-newCollection .form-input small {
            color: #666;
        }
        .weflix-admin-newCollection .form-label small {
            font-size: 12px;
            margin: 0px 0px 5px 0px;
        }
        .weflix-admin-newCollection .form-group.venda-type {
            padding: 0.875rem 0.75rem 1rem;
        }
        .weflix-admin-newCollection .venda-options {
            margin-top: 0;
            flex-direction: column;
            gap: 0.625rem;
        }
        .weflix-admin-newCollection .venda-option {
            flex: 1 1 auto;
        }
        .weflix-admin-newCollection .info-box-header h4 {
            font-size: 16px;
            color: #333333;
        }
        .weflix-admin-newCollection .info-box-content p {
            color: #666666;
        }
        .weflix-admin-newCollection .actions {
            padding: 10px 22px;
            align-items: center;
        }
    }
</style>
